import { Doc } from '@dadohr/shared/domainTypes/document';
import {
  ExperienceEventType,
  IExperience,
  IExperienceEventTaskDone,
  IExperienceEventTaskStart,
  IExperienceTemplate
} from '@dadohr/shared/domainTypes/experience';
import { Loader } from '../../../../components/Loader';
import { InstanceStatusChip } from '../../../../features/Experiences/components/InstanceStatusChip';
import { Centered } from '../../../../layout/Centered';
import { useExperienceTemplateById } from '../../../../services/experiences/template';
import { PRECISE_DATE, Timestamp, toMoment } from '../../../../services/time';

export const ExperienceInstance = ({
  tpl,
  exp
}: {
  tpl: Doc<IExperienceTemplate>;
  exp: Doc<IExperience>;
}) => {
  const { startsAt, finishedAt, status } = exp.data;
  const formatDate = (ts: Timestamp) => toMoment(ts).format(PRECISE_DATE);

  return (
    <div>
      <h4>{tpl.data.title}</h4>
      <ul>
        <li>
          Status: <InstanceStatusChip status={status} />
        </li>
        <li>Starts at: {formatDate(startsAt)}</li>
        <li>Expected end: {formatDate(exp.data.expectedEnd)}</li>
        <li>Finished at: {finishedAt ? formatDate(finishedAt) : '-'}</li>

        <li>
          <div>TASKS</div>
          <ul>
            {exp.data.tasks.map((t) => {
              const startEvent = exp.data.events.find(
                (e): e is IExperienceEventTaskStart =>
                  e.type === ExperienceEventType.TASK_START && e.taskId === t.id
              );
              const doneEvent = exp.data.events.find(
                (e): e is IExperienceEventTaskDone =>
                  e.type === ExperienceEventType.TASK_DONE && e.taskId === t.id
              );
              return (
                <li key={t.id}>
                  <div>{t.id}</div>
                  <ul>
                    <li>
                      Status: {t.status} {doneEvent?.late ? 'LATE' : ''}
                    </li>
                    <li>
                      Started at: {startEvent ? formatDate(startEvent.at) : '-'}
                    </li>
                    <li>
                      Finished at: {doneEvent ? formatDate(doneEvent.at) : '-'}
                    </li>
                    <li>
                      <div>Sub Tasks</div>
                      <ul>
                        {t.subTasks.map((s) => {
                          return (
                            <li key={s.id}>
                              <div>{s.id}</div>
                              <ul>
                                <li>Status: {s.status}</li>
                              </ul>
                            </li>
                          );
                        })}
                      </ul>
                    </li>
                  </ul>
                </li>
              );
            })}
          </ul>
        </li>
      </ul>
    </div>
  );
};

export const ExperienceInstanceWithoutTemplate = ({
  exp
}: {
  exp: Doc<IExperience>;
}) => {
  const [tpl, loading] = useExperienceTemplateById(exp.data.templateId);
  if (loading) {
    return <Loader height={200} />;
  }
  if (!tpl) {
    return <Centered>Template not found</Centered>;
  }

  return <ExperienceInstance exp={exp} tpl={tpl} />;
};
